<template lang='pug'>
  el-card.buying-brief(v-loading="loading")
    basic-info-view
    .card-title
      p Buying Brief
    hr.divider
    span(
      v-if="data.buying_brief_path == null && !isOpen"
      style="color:#cccccc"
    ) {{ $t('暂无Buying Brief') }}

    template(
      v-else
    )
      el-row(:gutter="20")
        el-col.required(
          style="width: 180px"
        ) Buying Brief
        el-col(
          :span="10"
          style="display:flex"
        )
          new-upload-file(
            v-if="isOpen"
            style="margin-right: 10px"
            :params="{file_type: 17}"
            axiosUrl="/management/subfinal/saveFile"
            @uploadSuccess="uploadSuccess"
          )
          uploaded-file-display(
            :fileName="data.file_name"
            :downloadUrl="data.file_download_path"
            :fileNameList="data.file_name_list"
          )
      el-row(
        v-if="isOpen"
        :gutter="20"
      )
        el-col(
          :span="10"
          style="margin-left: 180px"
        )
          footer-button(
            @confirm="onConfirm"
            @cancel="onCancel"
          )
</template>

<script>
import axios from 'axios'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
// import _ from 'lodash'
// import { format4backend } from '@/umcc/util'
import FooterButton from '@/components/FooterButton'
import BasicInfoView from '../components/BasicInfoView'

export default {
  components: {
    NewUploadFile,
    UploadedFileDisplay,
    FooterButton,
    BasicInfoView
  },
  data () {
    return {
      loading: false,
      data: {

      }
    }
  },
  computed: {
    ECTab () {
      return this.$store.state.campaign.ECTab
    },
    isOpen () {
      if (this.ECTab == null || this.ECTab.filter(i => i.tab_name === 'tab_buying_brief').length === 0) return false
      const res = this.$store.state.campaign.ECTab.filter(i => i.tab_name === 'tab_buying_brief')
      return res[0].is_open
    },
    taskId () {
      if (this.ECTab == null || this.ECTab.filter(i => i.tab_name === 'tab_buying_brief').length === 0) return null
      const res = this.$store.state.campaign.ECTab.filter(i => i.tab_name === 'tab_buying_brief')
      return res[0].task_id
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    }
  },
  async mounted () {
    this.loading = true
    await this.$store.dispatch('campaign/updateECCampaignInfo')
    if (this.$store.state.campaign.ECTab === null) {
      await this.$store.dispatch('campaign/updateECTab')
    }
    this.getSOW()
  },
  methods: {
    async onConfirm () {
      if (this.data.buying_brief_path == null) {
        this.$message.error(this.$t('请上传 Buying Brief'))
        return
      }
      const params = {
        task_id: this.taskId,
        sub_final_scope_id: this.subFinalScopeId,
        buying_brief_path: this.data.buying_brief_path
      }
      this.loading = true
      try {
        await axios.get('/management/ec/uploadBuyingBrief', {
          params: params
        })
        await this.$store.dispatch('campaign/updateECTab')
        this.$message.success(this.$t('提交成功'))
        this.loading = false
      } catch (err) {
        this.loading = false
        throw new Error()
      }
    },
    onCancel () {

    },
    uploadSuccess (res) {
      this.data.file_name = res.file_name
      this.data.file_download_path = res.file_download_path
      this.data.buying_brief_path = res.file_path
    },
    getSOW () {
      this.loading = true
      axios.get('/management/ec/getSOW', {
        params: {
          sub_final_scope_id: this.subFinalScopeId || this.$store.state.campaign.subFinalScopeId
        }
      })
        .then(res => {
          this.data = res
          this.$store.commit('campaign/setSubFinalScopeInfo', res)
          this.$forceUpdate()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang='stylus'>
.buying-brief
  p
    font-size 16px
    color #2c3031
  .divider
    margin 24px 0
</style>
